import { render } from "./PassportStatus.vue?vue&type=template&id=50ecf57b"
import script from "./PassportStatus.vue?vue&type=script&lang=js"
export * from "./PassportStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__